import axios from "axios";
import { baseUrl, defaultAddErrorMessage, errorTranslate } from "../util";
import Swal from "sweetalert2";

export const getProductProcessIntermediateTotal = ({
  id,
  setProdInv = function () {
    return;
  },
  setSystemBoundary = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/" +
      id +
      "/product-process-sold-intermediate-total",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setProdInv(response.data.prod);
      setSystemBoundary(response.data.prod.systemboundary);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createSystemBoundaryProductProcessIntermediate = ({
  productId,
  systemBoundary,
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    systemboundary: systemBoundary,
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/" +
      productId +
      "/product-process-sold-intermediate-total",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};
